var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 29,
    viewBox: "0 0 58 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3076 29H30.2816V0H37.3103L37.3076 29ZM27.7512 14.5C27.733 17.6829 26.4372 20.7284 24.1486 22.9671C21.86 25.2058 18.7658 26.4545 15.5463 26.4386C8.80855 26.4386 3.33325 21.0852 3.33325 14.5C3.35285 11.3175 4.64912 8.27285 6.93742 6.03445C9.22573 3.79606 12.319 2.54694 15.5381 2.56138C22.2759 2.56138 27.7512 7.9012 27.7512 14.5ZM19.2432 14.5C19.2503 13.7757 19.0395 13.0656 18.6376 12.46C18.2357 11.8543 17.6608 11.3804 16.9859 11.0983C16.3111 10.8163 15.5667 10.7388 14.8472 10.8759C14.1278 11.0129 13.4657 11.3582 12.9451 11.8679C12.4245 12.3776 12.0689 13.0287 11.9233 13.7386C11.7778 14.4485 11.8489 15.1852 12.1276 15.8551C12.4063 16.525 12.8801 17.0979 13.4888 17.5011C14.0975 17.9043 14.8136 18.1195 15.5463 18.1196C16.0296 18.1224 16.5087 18.031 16.9562 17.8506C17.4037 17.6701 17.8108 17.4042 18.1542 17.0679C18.4976 16.7317 18.7706 16.3318 18.9574 15.8912C19.1443 15.4506 19.2414 14.9778 19.2432 14.5ZM55.081 7.23372H50.4153L47.6708 9.91448L44.9263 7.23372H40.2606V11.8816L42.964 14.5271L40.2606 17.1726V21.7581H44.9977L47.6736 19.1398L50.3467 21.7581H55.0837V17.1726L52.3831 14.5271L55.0837 11.8816V7.23914L55.081 7.23372Z",
    fill: "#3A77FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlx);
export default __webpack_public_path__ + "static/media/OLX.808aedfe02c37140e84b037a79fb90e6.svg";
export { ForwardRef as ReactComponent };